import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AppNotification {
  id: string
  approvalId: string
  message: string
  href: string
  createdAt: string
  read: boolean
}

interface NotificationsState {
  notifications: AppNotification[]
  addNotification: (n: Omit<AppNotification, 'read'>) => void
  markAllRead: () => void
  clearOlderThan: (ms: number) => void
}

export const useNotificationsStore = create<NotificationsState>()(
  persist(
    (set) => ({
      notifications: [],

      addNotification: (n) =>
        set((s) => {
          // Evita duplicatas pelo approvalId.
          if (s.notifications.some((x) => x.approvalId === n.approvalId))
            return s
          return {
            notifications: [{ ...n, read: false }, ...s.notifications].slice(
              0,
              50,
            ),
          }
        }),

      markAllRead: () =>
        set((s) => ({
          notifications: s.notifications.map((n) => ({ ...n, read: true })),
        })),

      clearOlderThan: (ms) => {
        const cutoff = Date.now() - ms
        set((s) => ({
          notifications: s.notifications.filter(
            (n) => new Date(n.createdAt).getTime() > cutoff,
          ),
        }))
      },
    }),
    { name: 'vectraclip-notifications' },
  ),
)
